export const TRAFFIC_LIGHT_RED = 'RED';
export const TRAFFIC_LIGHT_YELLOW = 'YELLOW';
export const TRAFFIC_LIGHT_GREEN = 'GREEN';
